<template>
  <div class="title">
    <h1>Experience</h1>
<!--     <Tabs>
      <Tab name="Summary" :selected="true"> -->
        <Summary />
      <!-- </ Tab>
      <Tab name="Layerth">
        <img src="../assets/layerth.png" class="logo">
      </Tab>
      <Tab name="Blue Mesa Health">
        <img src="../assets/bluemesa.png" class="logo">
      </Tab>
      <Tab name="Stanley Park Ventures">
        <img src="../assets/spv.png" class="logo">
      </Tab>
    </Tabs> -->
  </div>
</template>

<script>
// import Tabs from './Tabs.vue'
// import Tab from './Tab.vue'
import Summary from './Summary.vue'

export default {
  name: 'Experience',
  components: {
    // Tabs,
    // Tab,
    Summary
  },
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.logo {
  height: 50px;
}
</style>
